import { render, staticRenderFns } from "./DashboardWidgetStreaming.vue?vue&type=template&id=3a1aa80e"
import script from "./DashboardWidgetStreaming.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardWidgetStreaming.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports